"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rexReducer = void 0;
exports.loadNewForm = loadNewForm;
exports.externalResetChildForm = externalResetChildForm;
exports.externalResetFields = externalResetFields;
const redux_1 = require("redux");
const composure_1 = require("@icg360/composure");
const form_1 = __importStar(require("../modules/form"));
const models_1 = __importStar(require("../modules/models"));
const immer_1 = require("immer");
const current_form_1 = __importDefault(require("../modules/current-form"));
const config_1 = __importDefault(require("../modules/config"));
const form_ids_1 = __importDefault(require("../modules/form-ids"));
const child_names_1 = __importDefault(require("../modules/child-names"));
const rulesets_1 = __importDefault(require("../modules/rulesets"));
const version_1 = __importDefault(require("../modules/version"));
const selectors_1 = require("../modules/selectors");
const model_parser_1 = require("@icg360/composure/lib/model-parser");
function loadNewForm(payload) {
    const { forms } = payload;
    if (Array.isArray(forms)) {
        return (0, form_1.loadNewForm)({
            ...payload,
            forms,
        });
    }
    const productForm = forms.type === 'product-form'
        ? forms
        : forms.forms[forms.defaultForm || 'binding'];
    const csRulesets = productForm.rulesets
        ? convertToLegacyRuleset(productForm.rulesets.refs)
        : {};
    return {
        type: composure_1.LOAD_FORM,
        payload: {
            version: 2,
            modelKey: payload.id,
            model: addRulesetsToMeta((0, model_parser_1.processFormModel)(productForm.model), csRulesets),
            layout: productForm.layout,
            submissions: productForm.submissions || {
                type: 'submissions-root',
            },
            rulesets: csRulesets,
            ...mapData(payload.initialData, payload.elementInjections),
        },
    };
}
function externalResetChildForm(useForm) {
    return (dispatch, getState, thirdArg) => {
        const state = getState();
        const currentForm = (0, selectors_1.useFormOrCurrent)(state, { useForm });
        if (state.rex.version[currentForm.id] > 1) {
            const fields = [];
            const stage = state.rex.composure[currentForm.id].layout.stages[currentForm.stage];
            for (const stageItem of stage.items) {
                if (stageItem.type === 'section') {
                    for (const sectionItem of stageItem.items) {
                        if (sectionItem.type === 'control' ||
                            sectionItem.type === 'display' ||
                            sectionItem.type === 'input') {
                            if (sectionItem.term) {
                                fields.push(sectionItem.term);
                            }
                        }
                    }
                }
            }
            return externalResetFields({ useForm: currentForm, fields })(dispatch, getState, thirdArg);
        }
        return (0, models_1.externalResetChildForm)(useForm)(dispatch, getState, thirdArg);
    };
}
function externalResetFields({ useForm, fields, }) {
    return (dispatch, getState, thirdArg) => {
        const state = getState();
        const currentForm = (0, selectors_1.useFormOrCurrent)(state, { useForm });
        if (state.rex.version[currentForm.id] > 1) {
            const termValues = {};
            for (const field of fields) {
                termValues[field] = '';
            }
            return dispatch({
                type: composure_1.UPDATE_TERM_VALUES,
                payload: {
                    modelKey: currentForm.id,
                    termValues,
                },
            });
        }
        return (0, models_1.externalResetFields)({ useForm: currentForm, fields })(dispatch, getState, thirdArg);
    };
}
function mapData(initialData = {}, elementInjections = {}) {
    return {
        initialTermValues: elementInjections.EffectiveDateRange
            ? {
                ...initialData,
                EffectiveDateRange: elementInjections.EffectiveDateRange,
            }
            : initialData,
        envData: {
            LocationId: elementInjections.PolicyRequest?.locationid || '',
            Roles: elementInjections.PolicyRequest?.username === 'cru4admin'
                ? ['MANAGER']
                : [],
            LastModifiedDate: elementInjections.LastModifiedDate ||
                elementInjections.CreatedDate ||
                '',
            CreatedDate: elementInjections.CreatedDate || '',
            UserAgent: elementInjections.PolicyRequest?.useragent || '',
            usergent: elementInjections.PolicyRequest?.useragent || '',
        },
    };
}
function convertToLegacyRuleset(rulesetRefs) {
    const rulesets = {};
    rulesetRefs.forEach((ruleset, index) => {
        rulesets['ruleset' + index] = {
            action: '${ixlogic}rest/simple.cfm',
            highlightControls: ruleset.data
                ?.filter((r) => r.term && r.willHighlight)
                .map((r) => r.term)
                .join(' '),
            idref: ruleset.idref,
            outcome: ruleset.onTrue.toLowerCase(),
            referable: ruleset.referable,
            data: ruleset.data?.filter((r) => r.type === 'ruleset-data'),
        };
    });
    return rulesets;
}
function addRulesetsToMeta(model, rulesets) {
    return (0, immer_1.produce)(model, (draft) => {
        for (const [rulesetId, ruleset] of Object.entries(rulesets)) {
            if (!ruleset.data) {
                continue;
            }
            for (const rulesetDataItem of Object.values(ruleset.data)) {
                if (rulesetDataItem.term) {
                    const term = draft.terms[rulesetDataItem.term];
                    if (!term) {
                        console.warn(`Term did not exist for ruleset ${rulesetId}: ${rulesetDataItem.term}`);
                        continue;
                    }
                    if (!term.meta) {
                        term.meta = {};
                    }
                    if (term.meta.rulesets) {
                        term.meta.rulesets += ',' + rulesetId;
                    }
                    else {
                        term.meta.rulesets = rulesetId;
                    }
                }
            }
        }
    });
}
const initialState = {};
const formModelReducer = (0, immer_1.produce)((draft, action) => {
    switch (action.type) {
        case composure_1.LOAD_FORM: {
            composure_1.mutations.loadForm(draft, 
            // Hack alert: Add a meta value to terms of type date that have validation
            // in Rex those are called "range" types
            // we will read this meta in derive-form.ts
            (0, immer_1.produce)(action.payload, addDateRangeMeta));
            break;
        }
        case composure_1.UPDATE_TERM_VALUES: {
            composure_1.mutations.updateTermValues(draft, action.payload);
            break;
        }
        case 'rex/EXTERNAL_MODEL_UPDATE': {
            const { data, formId, elementInjections } = action;
            if (draft[formId] === undefined) {
                // Not for us, the form was loaded as a v1 form
                return;
            }
            composure_1.mutations.updateTermValues(draft, {
                modelKey: formId,
                termValues: elementInjections?.EffectiveDateRange
                    ? {
                        ...data,
                        EffectiveDateRange: elementInjections?.EffectiveDateRange,
                    }
                    : data,
                // TODO: map elementInjections to envData
                // envData: elementInjections ?? {}
            });
            break;
        }
        case composure_1.UPDATE_TERM_VALUE: {
            composure_1.mutations.updateTermValue(draft, action.payload);
            break;
        }
        case composure_1.TERM_INPUT: {
            composure_1.mutations.termInput(draft, action.payload);
            break;
        }
        case composure_1.ITERABLE_COUNT: {
            composure_1.mutations.iterableCount(draft, action.payload);
            break;
        }
        case composure_1.ITERABLE_ADD: {
            composure_1.mutations.iterableAdd(draft, action.payload);
            break;
        }
        case composure_1.ITERABLE_REMOVE: {
            composure_1.mutations.iterableRemove(draft, action.payload);
            break;
        }
        case composure_1.ACTION_DISPATCH: {
            composure_1.mutations.dispatchActions(draft, action.payload);
            break;
        }
        case composure_1.REMOVE_FORM: {
            composure_1.mutations.removeForm(draft, action.payload);
            break;
        }
        case 'rex/LOAD_NEW_FORMS':
        case 'rex/REMOVE_FORM': {
            composure_1.mutations.removeForm(draft, {
                modelKey: action.id,
            });
            break;
        }
        default:
            break;
    }
}, initialState);
const initialComposureState = {};
const composureReducer = (0, immer_1.produce)((draft, action) => {
    switch (action.type) {
        case composure_1.LOAD_FORM: {
            draft[action.payload.modelKey] = {
                model: action.payload.model,
                layout: action.payload.layout,
                submissions: action.payload.submissions,
                rulesets: action.payload.rulesets,
            };
            break;
        }
        case 'rex/REMOVE_FORM': {
            delete draft[action.id];
            break;
        }
    }
}, initialComposureState);
exports.rexReducer = (0, redux_1.combineReducers)({
    forms: form_1.default,
    currentForm: current_form_1.default,
    formIds: form_ids_1.default,
    models: models_1.default,
    config: config_1.default,
    childNames: child_names_1.default,
    rulesets: rulesets_1.default,
    version: version_1.default,
    formModel: formModelReducer,
    composure: composureReducer,
});
function addDateRangeMeta(payload) {
    for (const term of Object.values(payload.model.terms)) {
        if (term.valueType === 'date' &&
            term.validationList?.some((v) => v.validationType === 'date-range')) {
            if (!term.meta) {
                term.meta = {
                    isDateRange: 'true',
                };
            }
            else {
                term.meta.isDateRange = 'true';
            }
        }
    }
    for (const iterable of Object.values(payload.model.iterables)) {
        for (const term of Object.values(iterable.terms)) {
            if (term.valueType === 'date' &&
                term.validationList?.some((v) => v.validationType === 'date-range')) {
                if (!term.meta) {
                    term.meta = {
                        isDateRange: 'true',
                    };
                }
                else {
                    term.meta.isDateRange = 'true';
                }
            }
        }
    }
}
//# sourceMappingURL=index.js.map